import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY } from '../api/constants';

// Create a single instance of the Stripe promise to be reused throughout the app
let stripePromise;

/**
 * Get the Stripe promise instance
 * @returns {Promise} The Stripe promise
 */
export const getStripePromise = () => {
  if (!stripePromise) {
    console.log('Initializing Stripe with key:', STRIPE_PUBLIC_KEY);
    stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
  }
  return stripePromise;
};

// Pre-load Stripe to ensure it's ready when components need it
getStripePromise();
